import script from "./PersonFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonFilter.vue?vue&type=script&setup=true&lang=ts"

import "./PersonFilter.vue?vue&type=style&index=0&id=5db0bed4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db0bed4"]])

export default __exports__